export const DEFAULT_LANGUAGE = 'en_us';

export const ISO_DEFAULT_LANGUAGE = 'en-US';

const DEFAULT_DIVIDER = '-';

const OVERRIDDEN_ISO_LOCALES: Record<string, string> = {
  en: 'en-US',
  ja: 'ja-JP',
  no: 'nb-NO',
  sv: 'sv-SE',
  uk: 'uk-UA'
};

const DATE_FNS_LOCALES: Record<string, string> = {
  'en-GB': 'en-GB',
  'en-US': 'en-US',
  'zh-TW': 'zh-TW',
  'zh-HK': 'zh-HK',
  'zh-CN': 'zh-CN',
};

/**
 * @param {string} locale
 * @returns {{ country: string, language: string }}
 */
export const getLocaleDetails = (locale: string): { country: string, language: string } => {
  const regexp = /^(?<country>[a-z]{2})((?<divider>_|-)(?<language>[a-z]+))?$/i;
  const matches = (OVERRIDDEN_ISO_LOCALES[locale] ?? locale)?.match(regexp);

  if (matches) {
    const [, country,,, language] = matches;
    return {
      country: country.toLowerCase(),
      language: (language ?? country).toUpperCase()
    };
  }
  return getLocaleDetails(DEFAULT_LANGUAGE);
};

/**
 * @param {string} locale
 * @param {string} divider
 * @returns {string}
 * @example
 *    getISOLocale('en-US') // 'en-US'
 *    getISOLocale('fr', '-') // 'fr-FR'
 */
export const getISOLocale = (locale: string, divider: string = DEFAULT_DIVIDER) => {
  const { country, language } = getLocaleDetails(locale);
  return `${country.toLowerCase()}${divider}${language.toUpperCase()}`;
};

/**
 * @param {string} locale
 * @returns {{ i18n: string, ui: string, date: string }}
 */
export const getLocaleUsage = (locale: string) => {
  const { country } = getLocaleDetails(locale);

  const i18nLocale = getISOLocale(locale);
  const dateLocale = DATE_FNS_LOCALES[i18nLocale] ?? country;

  return {
    i18n: i18nLocale, // Intl
    ui: getISOLocale(locale, '_'), // Antd
    date: dateLocale // date-fns
  };
};
